import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import Hide from "./Hide";
var Desktop = /*#__PURE__*/ React.forwardRef(function(_param, ref) {
    var children = _param.children, props = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ _jsx(Hide, _object_spread_props(_object_spread({
        ref: ref,
        $on: [
            "small"
        ]
    }, props), {
        children: children
    }));
});
Desktop.displayName = "Desktop";
export default Desktop;
